"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.check = check;
const formatFunctions_1 = require("../formatFunctions");
/**
 * Sprawdza czy tekst jest podanego formatu
 * @param format format tekstu
 * @param value wartośc do weryfikacji
 */
function check(format, value) {
    return (0, formatFunctions_1.checkFormat)(format, value);
}
//# sourceMappingURL=check.js.map